(function() {
  var CFG = window.__ipLocalization;
  if (!CFG) return;

  function resolve(isoCode) {
    isoCode = (isoCode || '').toString().toUpperCase().trim();
    if (!isoCode) return fallback();

    var inMarket = CFG.marketCountries.indexOf(isoCode) !== -1;

    var countryInfo = null;
    var continentName = null;

    // 优先通过 iso_code 匹配
    for (var i = 0; i < CFG.continents.length; i++) {
      var regions = CFG.continents[i].regions || [];
      for (var j = 0; j < regions.length; j++) {
        var r = regions[j];
        if (r.iso_code && r.iso_code.toString().toUpperCase() === isoCode) {
          countryInfo = r;
          continentName = CFG.continents[i].continent;
          break;
        }
      }
      if (countryInfo) break;
    }

    // 若元字段没有 iso_code，用 Intl.DisplayNames 获取国家名后再匹配 region
    // if (!countryInfo) {
    //   var countryName = null;
    //   try {
    //     var dn = new Intl.DisplayNames(['en'], { type: 'region' });
    //     countryName = dn.of(isoCode);
    //   } catch (e) {}
    //   if (countryName) {
    //     for (var i = 0; i < CFG.continents.length; i++) {
    //       var regions = CFG.continents[i].regions || [];
    //       for (var j = 0; j < regions.length; j++) {
    //         var r = regions[j];
    //         if (r.region && r.region === countryName) {
    //           countryInfo = r;
    //           continentName = CFG.continents[i].continent;
    //           break;
    //         }
    //       }
    //       if (countryInfo) break;
    //     }
    //   }
    // }

    var displayName, displayCurrency, displayIsoCode;
    var spCurrency = (CFG.countryCurrencyMap && CFG.countryCurrencyMap[isoCode]) || null;

    // 1. 店铺市场包含用户ip对应的国家
    if (inMarket) {
      displayName = countryInfo ? countryInfo.region : CFG.fallbackCountryName;
      // 优先 Shopify Payment 货币 → 元字段货币 → fallback
      displayCurrency = spCurrency || (countryInfo && countryInfo.currency ? countryInfo.currency : CFG.fallbackCountryCurrency);
      displayIsoCode = isoCode;
    } else { // 2. 店铺市场不包含用户ip对应的国家,使用店铺默认货币
      displayCurrency = CFG.shopCurrency || CFG.fallbackCountryCurrency;
      displayName = CFG.defaultRegionName || CFG.fallbackCountryName;
      displayIsoCode = isoCode;
    }

    return { displayName: displayName, displayCurrency: displayCurrency, displayIsoCode: displayIsoCode };
  }

  function fallback() {
    return {
      displayName: CFG.fallbackCountryName,
      displayCurrency: CFG.fallbackCountryCurrency,
      displayIsoCode: CFG.fallbackCountryIsoCode
    };
  }

  function updateUI(data) {
    if (!data) return;

    var toggles = document.querySelectorAll('[data-ip-toggle-text]');
    for (var i = 0; i < toggles.length; i++) {
      toggles[i].textContent = data.displayName + '(' + data.displayCurrency + ')';
    }

    var titles = document.querySelectorAll('[data-ip-modal-title]');
    for (var i = 0; i < titles.length; i++) {
      titles[i].textContent = data.displayName + '(' + data.displayCurrency + ')';
    }

    var tpl = CFG.currencyDescription || '';
    var nameHtml = '<span class="currency-selector-modal__name">' + data.displayName + '</span>';
    var currencyHtml = '<span class="currency-selector-modal__name">' + data.displayCurrency + '</span>';
    var subtitles = document.querySelectorAll('[data-ip-modal-subtitle]');
    for (var i = 0; i < subtitles.length; i++) {
      subtitles[i].innerHTML = tpl
        .replace(/\[\[region\]\]/g, nameHtml)
        .replace(/\[\[currency\]\]/g, currencyHtml);
    }
  }

  if (window.__ipLocalizationInitialized) return;
  window.__ipLocalizationInitialized = true;

  var COOKIE_ISO_NAME = 'localization';
  var COOKIE_DAYS = 30;

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function setCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + (days || COOKIE_DAYS) * 864e5);
    document.cookie = name + '=' + encodeURIComponent(value) + ';expires=' + d.toUTCString() + ';path=/';
  }

  function getUrlParam(name) {
    try {
      return new URLSearchParams(window.location.search).get(name);
    } catch (e) { return null; }
  }

  function init() {
    
    var cachedIso = getCookie(COOKIE_ISO_NAME);
    // URL 带 country 参数时不做 IP 检测，直接跳转由 Shopify 处理
    if (getUrlParam('country')) return;

    // 从 cookie 读取缓存的 iso, 走 resolve
    if (cachedIso) {
      try { updateUI(resolve(cachedIso)); } catch (e) {}
      return;
    }    

    // 兜底，无 cookie 且无 country 参数时才请求 IP API
    fetch('https://api.syrokan.cc/', { method: 'GET' })
      .then(function(res) { return res.text(); })
      .then(function(text) {
        var iso = (text || '').trim();
        if (iso) {
          setCookie(COOKIE_ISO_NAME, iso);
          updateUI(resolve(iso));
        }
      })
      .catch(function() {
        // API 失败时保持 Liquid fallback，不报错
      });
  }

  // 点击国家选项：更新 cookie + 刷新 UI
  document.addEventListener('click', function(e) {
    var option = e.target.closest('[data-disclosure-option]');
    if (!option) return;

    // 用户手动切换国家：给跳转链接加 geo_skip 参数，并在当前页写入 session 标记，
    // 防止 theme.liquid 中的 geoRedirect 自动跳转覆盖用户选择
    try {
      var skipUrl = new URL(option.href);
      skipUrl.searchParams.set('geo_skip', '1');
      option.href = skipUrl.toString();
      sessionStorage.setItem('ql_geo_manual_skip', '1');
    } catch (err) {}

    var isoCode = option.getAttribute('data-iso-code');
    var region  = option.getAttribute('data-region');
    if (!isoCode) return;

    // 优先使用 Shopify Payment 货币，未开通则用店铺默认货币
    // var currency = (CFG.countryCurrencyMap && CFG.countryCurrencyMap[isoCode]) || CFG.shopCurrency || CFG.fallbackCountryCurrency;
    // updateUI({ displayName: region, displayCurrency: currency, displayIsoCode: isoCode });
  });

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
